export default __webpack_public_path__ + "static/LeituraSansTwo-LightItalic-cf53235f64a70ff7a9ec728ea87b049f.woff2";